<template>
  <div class="scheduleList">
    <HearderTitle name="排班管理" />
    <div class="tableBox">
      <div class="tool_bar">
        <el-form :inline="true" :model="queryInfo">
          <el-form-item label="时间">
            <el-date-picker prefix-icon=" " v-model="queryInfo.time" type="month" placeholder="请选择" value-format="yyyy-MM"> </el-date-picker>
          </el-form-item>
          <el-form-item style="margin-left: -10px">
            <el-button class="lightBlueBtn searchBtn" type="primary" size="small" @click="search()">查询</el-button>
          </el-form-item>
          <el-form-item style="float: right; margin-right: 0">
            <el-button class="lightBlueBtn" type="primary" size="small">导入排班表</el-button>
          </el-form-item>
        </el-form>
      </div>
      <div class="table">
        <el-table :key="key" ref="refTable" border header-cell-class-name="h_bg" :data="tableData" style="width: 100%">
          <el-table-column prop="" label="人员" width="80" align="center">
            <template slot="header"> {{ queryInfo.time }} </template>
          </el-table-column>
          <el-table-column v-for="item in lastMonthDay" :key="item" align="center">
            <template #header> {{ item }} </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
  </div>
</template>

<script>
  import HearderTitle from '@/components/HearderTitle'
  export default {
    name: 'scheduleList',
    data() {
      return {
        queryInfo: {
          // 当前页
          pageNum: 1,
          // 每页数量
          pageSize: 14,
          time: '',
        },
        tableData: [],
        total: 0,
        lastMonthDay: 0,
        key: 0,
      }
    },
    created() {
      this.queryInfo.time = this.getNowMonth()
      this.lastMonthDay = this.getLastMonthDay(this.queryInfo.time)
    },
    components: { HearderTitle },
    methods: {
      search() {
        this.lastMonthDay = this.getLastMonthDay(this.queryInfo.time)
      },
      getNowMonth() {
        let date = new Date()
        let year = date.getFullYear()
        let month = date.getMonth() + 1
        month = month > 9 ? month : '0' + month
        let nowMonth = year + '-' + month
        return nowMonth
      },
      getLastMonthDay(month) {
        let time = month.split('-')
        let day = new Date(time[0], time[1], 0).getDate()
        return day
      },
    },
  }
</script>

<style lang="less">
  .scheduleList {
    .table .el-table .el-table__cell {
      padding: 5px 0;
    }
    .tableBox {
      .select {
        color: #015293;
        font-size: 12px;
        cursor: pointer;
      }
      .tool_bar {
        padding-top: 18px;
        padding-bottom: 18px;
        font-size: 14px;
        color: #888;
        .el-form-item {
          margin-right: 20px;
          margin-bottom: 0;
          .el-input__inner {
            width: 220px;
            height: 32px;
          }
          .el-input__inner {
            padding-left: 10px;
          }
          .middle {
            padding: 0 10px;
          }
          .searchBtn {
            width: 82px;
          }
        }
      }
      .el-table {
        min-height: 685px;
        &::before {
          height: 0;
        }
      }
    }
  }
  .auditionDialog {
    .el-dialog__header {
      border-bottom: 1px solid #dcdfe6;
    }
    .el-dialog__body {
      padding-bottom: 0;
      overflow: hidden;
      .el-form-item {
        margin-bottom: 15px;
      }
    }
    .el-date-editor.el-input,
    .el-date-editor.el-input__inner,
    .el-textarea__inner {
      width: 178px;
    }
    .el-input__inner {
      padding-left: 15px;
      width: 178px;
    }
    .searchBtn {
      width: 112px;
    }
  }
  .uploadDialog {
    .el-dialog__header {
      border-bottom: 1px solid #dcdfe6;
    }
    .el-form {
      .el-form-item {
        &:last-child {
          margin-bottom: 0;
          .el-button {
            float: right;
            width: 112px;
            height: 32px;
            padding: 0;
            text-align: center;
          }
        }
      }
    }
  }
</style>
